webpackJsonp([142629428675168],{

/***/ 394:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Jeff Chan"}},"allMarkdownRemark":{"edges":[{"node":{"excerpt":"The last time I had a  public blog  was in high school. The blog was titled  The Jeff Channel , and  The Geeky Jeffy Zone  prior to that…","fields":{"slug":"/blog-redux/"},"frontmatter":{"date":"03 August, 2018","title":"Blog Redux"}}}]}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---index-48e8083872e153341da0.js